"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "GaussianDropout", {
  enumerable: true,
  get: function () {
    return _GaussianDropout.default;
  }
});
Object.defineProperty(exports, "GaussianNoise", {
  enumerable: true,
  get: function () {
    return _GaussianNoise.default;
  }
});

var _GaussianDropout = _interopRequireDefault(require("./GaussianDropout"));

var _GaussianNoise = _interopRequireDefault(require("./GaussianNoise"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }